import Reveal from '@/components/feature/Reveal';
import { navLinks } from '@/mocks/home';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="grid grid-cols-1 gap-6 border-b border-background-50/15 py-12 md:grid-cols-2 md:items-center md:py-16">
            <div>
              <h2 className="font-heading text-2xl font-bold leading-snug md:text-3xl">
                入口随时在变，收藏这一页就够了
              </h2>
              <p className="mt-3 max-w-lg text-sm leading-relaxed text-primary-100 md:text-base">
                无论黑料官网入口、网址、地址怎么调整，你都可以回到本页获取最新可用的直达链接。
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row md:justify-end">
              <a
                href="#entry"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-login-box-line text-lg" />
                立即进入官网
              </a>
              <a
                href="#status"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-radar-line text-lg" />
                查看线路状态
              </a>
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-8 py-10 md:grid-cols-12 md:py-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-fire-line text-lg" />
              </span>
              <span className="font-heading text-xl font-bold">黑料官网</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-100">
              一个专注入口指引与社区讨论的导航页。所有线路每小时自动校验，入口变化第一时间同步。
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-sm font-bold text-background-50">站内导航</h3>
            <ul className="mt-4 space-y-2">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="cursor-pointer whitespace-nowrap text-sm text-primary-100 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-sm font-bold text-background-50">站点信息</h3>
            <ul className="mt-4 space-y-3 text-sm text-primary-100">
              <li className="flex items-center gap-2">
                <i className="ri-refresh-line text-base" />
                入口更新时间：2026 年 9 月 11 日
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-base" />
                校验频率：每小时一次
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-information-line text-base" />
                本页仅提供入口指引，不收集账号信息
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-2 border-t border-background-50/15 py-6 text-xs text-primary-200 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 黑料官网 · 入口导航页</p>
          <p>内容由社区用户共同维护，请理性讨论</p>
        </div>
      </div>
    </footer>
  );
}